import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, BackupFileViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from "primeng/table";
import { DeveloperApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate, formatNumber } from "@angular/common";




@Component({
  selector: 'app-backups-list-component',
  templateUrl: './backups-list.component.html',
  standalone: false
})
export class BackupsListComponent implements OnInit, AfterViewInit {



  public pageTitle: string = 'Backups';

  list: BackupFileViewModel[] = [];
  loadingList: boolean = true;

  @ViewChild('dt1') table?: Table;

  loading: boolean = false;


  currentBackup: null | BackupFileViewModel = null;
  dbPassword: null | string = null;
  dbPasswordConfirm: null | string = null;
  


  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: DeveloperApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      console.info('Loading ' , params);
    });

    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

    
  }

  ngAfterViewInit(): void {
    this.loadTable();
  }

  loadTable() {
    

    this.loadingList = true;
    this.apiService.ListS3Backups()
      .forEach(
        (result) => {
          this.list = result;


          if (this.authService.hasUserType(ArkUserType.Admin)) {
            this.apiService.ListDatabaseBackups()
              .forEach(
                (result2) => {
                  this.list = this.list.concat(result2);
                  this.loadingList = false;
                }).catch(
                  err => {
                    this.alertService.error(Utils.getAjaxError(err));
                    this.loadingList = false;
                  });
          }
          else {
            this.loadingList = false;
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }



  clear(table: Table) {
    this.table = table;
    table.clear();
  }



  getTimeFromNow(date: Date) {
    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(date);
  }
  formatMountainTime(date: Date) {

    return Utils.formatMountainTime(date);
  }

  formatSize(sizeMB: any) {

    return Utils.formatByteSize(sizeMB * 1024*1024);
  }
  download(item: BackupFileViewModel) {

    

    if (item.BackupLocation === 'AWS S3') {
      this.loading = true;
      this.apiService.GetS3BackupURL({ body: { name: item.Name || undefined } })
        .forEach(
          (url) => {
            this.loading = false;
            console.info('Download URL: ', url);
            const link = document.createElement('a');
            link.href = url;
            link.download = item.FileName || item.Name || 'Backup';
            link.click();
          }).catch(
            err => {
              this.loading = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    } else {
      // show password diaglo
      this.currentBackup = item;
      return;
      
    }
  }

  DoRequestBackup() {
    if (!this.currentBackup)
      return;

    if (!this.dbPassword || this.dbPassword.length < 10) {
      this.alertService.error('Invalid password');
      return;
    }
    if (!this.dbPasswordConfirm || this.dbPassword != this.dbPasswordConfirm) {
      this.alertService.error('Invalid confirm password');
      return;
    }



    this.loading = true;

    this.apiService.GetDatabaseBackupURL({ body: { name: this.currentBackup.Name || undefined, password: this.dbPassword } })
      .forEach(
        (email) => {
          this.loading = false;
          this.alertService.info(`Requested download for ${this.currentBackup!.Name} from ${this.currentBackup!.BackupLocation}. The link will be send to ${email}`);
          this.currentBackup = null;

          //this.loadTable();
        }).catch(
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          });

  } 
}
